export default "__VITE_ASSET__CRby4tew__"